import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PageTransition from "@/components/common/PageTransition";
import { RouteTransitionLoading } from "@/components/ui/RouteLoading";

function AppRouteOutlet() {
  const location = useLocation();
  return (
    <Suspense fallback={<RouteTransitionLoading />}>
      <PageTransition key={location.pathname}>
        <Outlet />
      </PageTransition>
    </Suspense>
  );
}

export { AppRouteOutlet };
